"use client";

import { useEffect, useState } from 'react';

export default function ScrollBackground() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement?.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progress = Math.min(scrolled / documentHeight, 1);
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate opacity based on scroll progress (0 to 0.08 for subtle effect)
  const opacity = scrollProgress * 0.08;

  return (
    <div 
      className="fixed inset-0 pointer-events-none z-0 transition-opacity duration-500 ease-out"
      style={{
        backgroundColor: `rgba(58, 77, 70, ${opacity})`,
      }}
    />
  );
}